var enCharMap = {
  // '\\': '\\u005c',
  // '0X': '\\u0030\\u0058',
  '&': "\\u0026",
  '[': "\\u005b",
  ']': "\\u005d",
  '@': "\\u0040",
  '<': "\\u003c",
  '>': "\\u003e",
  '{': "\\u007b",
  '}': "\\u007d",
  '/': "\\u002f",
  '|': "\\u007c",
  ':': "\\u003a",
  '"': "\\u0022",
  '+': "\\u002b",
  '(': "\\u0028",
  ')': "\\u0029",
  ' ': "\\u0020",
  ',': "\\u002c",
  '-': "\\u002d",
  '.': "\\u002e",
  '_': "\\u005f",
  '，': "\\uff0c",
  '。': "\\u3002",
  ';': "\\uff1b",
  '；': "\\u003b",
  '‘': "\\u2018",
  '’': "\\u2019",
  '！': "\\uff01",
  '“': "\\u201c",
  '”': "\\u201d",
  '【': "\\u3010",
  '】': "\\u3011",
  '…': "\\u2026",
  '（': "\\uff08",
  '）': "\\uff09",
  '—': "\\u2014",
  '、': "\\u3001",
  '《': "\\u300a",
  '》': "\\u300b",
  '？': "\\uff1f",
  '￥': "\\uffe5",
  '!': "\\u0021",
  '?': "\\u003f",
  '$': "\\u0024",
  '#': "\\u0023",
  '~': "\\u007e",
  '·': "\\u00b7",
  '`': "\\u0060",
  '%': "\\u0025",
  '^': "\\u005e",
  '*': "\\u002a",
  '：': "\\uff1a",
  '……': "\\u2026\\u2026",
  '「': "\\u300c",
  '」': "\\u300d",
  '\n': "\\u000a",
  '\r': "\\u000d",
  '≤': "\\u2264",
  '≥': "\\u2265",
  '＞': "\\uff1e",
  '℃': "\\u2103",
  '³': "\\u00b3",
  '=': "\\u003d"
};
export default enCharMap;